var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('app-primary', {
    scopedSlots: _vm._u([{
      key: "contentsHead",
      fn: function () {
        return [_c('sub-head-primary', {
          attrs: {
            "itemTitle": "단지안내",
            "tabActive": "커뮤니티",
            "bg": "/images/sub/complex/visual.jpg"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function () {
              return [_vm._v("단지안내")];
            },
            proxy: true
          }])
        })];
      },
      proxy: true
    }])
  }, [_c('page-section-primary', {
    staticClass: "page-section--first page-section--last",
    attrs: {
      "titWrapClass": "text-center"
    },
    scopedSlots: _vm._u([{
      key: "tit",
      fn: function () {
        return [_vm._v("커뮤니티")];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "page-section__content"
  }, [_c('div', {
    staticClass: "sub-tabs"
  }, [_c('v-tabs', {
    staticClass: "v-tabs--density-compact",
    attrs: {
      "grow": "",
      "hide-slider": "",
      "centered": ""
    },
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_vm._l(_vm.items, function (item, index) {
    return [_c('tab-quarternary', {
      key: index
    }, [_vm._v(" " + _vm._s(item.name) + " ")])];
  })], 2)], 1)]), _c('div', {
    staticClass: "page-section__content"
  }, [_c('v-tabs-items', {
    staticClass: "community-tabs-items",
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_vm._l(_vm.items, function (item, index) {
    return [_c('v-tab-item', {
      key: index,
      attrs: {
        "eager": ""
      }
    }, [_c('div', {
      staticClass: "image-wrap"
    }, [_c('v-img', {
      attrs: {
        "eager": "",
        "src": item.image
      }
    }, [_c('v-sheet', {
      staticClass: "pa-18px pa-md-40px",
      attrs: {
        "height": "100%",
        "color": "transparent"
      }
    }, [_c('v-row', {
      staticClass: "row--sm flex-column h-100 my-0"
    }, [_c('v-spacer'), _c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('tit', {
      staticClass: "tit--lg white--text line-height-1"
    }, [_vm._v(" " + _vm._s(item.name) + " ")])], 1), _c('v-col', {
      staticClass: "pb-0",
      attrs: {
        "cols": "auto"
      }
    }, [_c('txt', {
      staticClass: "txt--lg white--text line-height-11"
    }, [_vm._v(" " + _vm._s(item.text) + " ")])], 1)], 1)], 1)], 1)], 1)])];
  })], 2), _c('v-row', {
    attrs: {
      "no-gutters": "",
      "justify": "end"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('txt', {
    staticClass: "txt--sm txt--dark mt-8px"
  }, [_vm._v("* 실제 조성 이미지가 아닌 이해를 돕기 위한 이미지 입니다.")])], 1)], 1)], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }